
import XButton from 'vux/src/components/x-button/index.vue'

import { SaafHeader } from '@/common/components/index'
import { mapState } from 'vuex'



export default {
data () {
return {

}
},
components: {
SaafHeader,
XButton,
},
computed: {
...mapState({
userInfo: state => state.user.userInfo,
guideInfo: state => state.user.guideInfo,
shopInfo: state => state.user.shopInfo,
}),
},
created(){
console.log('created_',4)
},
activated(){
console.log('activated_',4)
},
mounted(){
console.log('mounted_',4)
},
destroyed(){
console.log('destroyed_',4)
},
methods: {

},
}




// WEBPACK FOOTER //
// ./src/page/demo/testCache4.vue